// Exportação para uso em módulos
import GomarkePixel from './pixel';
import { getConfigFromScriptTag } from './utils/getSetting';

export default GomarkePixel;

// Core Engine (Fase 1) - Visitor, Session, PageView, Queue
export {
  initCoreTracker,
  destroyCoreTracker,
  trackPageView as coreTrackPageView,
  getVisitor,
  getSession,
  getCoreSessionId,
  getCoreVisitorId,
  getPageViewState,
  getOrCreateVisitor,
  getOrCreateSession,
  enqueueEvent,
  flushQueue,
  startPeriodicFlush,
  stopPeriodicFlush,
  setupUnloadFlush,
  getQueueLength,
  type CoreTrackerConfig,
  setConsent,
  getConsent,
  shouldTrack,
  type QueueItem,
  type QueuePriority,
  type ConsentState,
  type Visitor,
  type CoreSession,
  type UtmData,
  type PageViewRecord,
} from './core';

// Behavior Engine (Fase 2) - scroll, click, idle, exit intent, viewport, engagement
export {
  initBehaviorEngine,
  getBehaviorState,
  enqueueBehaviorSnapshot,
  resetForNewPage,
  resetBehaviorState,
  destroyBehaviorEngine,
  computeEngagement,
  initViewportBehavior,
  getViewportState,
  destroyViewportBehavior,
  type BehaviorState,
  type BehaviorEngineConfig,
  type EngagementLevel,
  type EngagementResult,
  type ViewportConfig,
  type ViewportSelectorType,
} from './behavior';

// State central consolidado (Bloco 6)
export { getTrackerState, type TrackerState } from './state';

// Função para auto-inicialização via script tag
export async function autoInitFromScriptTag(): Promise<
  GomarkePixel | undefined
> {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  try {
    const scriptTag = document.currentScript as HTMLScriptElement | null;
    if (scriptTag && scriptTag.hasAttribute('data-pixel')) {
      const config = await getConfigFromScriptTag(scriptTag);
      return new GomarkePixel(config);
    }
  } catch (err) {
    console.warn('[GomarkePixel] Erro no autoInitFromScriptTag:', err);
  }
}

// Para uso global (IIFE) - versão corrigida
if (typeof window !== 'undefined') {
  // Usando IIFE assíncrona para evitar top-level await
  (async () => {
    const autoPixel = await autoInitFromScriptTag();
    if (autoPixel) {
      (window as unknown as { gomarkePixel: GomarkePixel }).gomarkePixel =
        autoPixel;
    }
  })();
}
